import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { HostPage } from './pages/HostPage';
import { JoinPage } from './pages/JoinPage';
import { ProjectorPage } from './pages/ProjectorPage';
import { LoginPage } from './pages/LoginPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { StudioPage } from './pages/StudioPage';
import { StudioModePage } from './pages/StudioModePage';
import { StudioMaterialPage } from './pages/StudioMaterialPage';
import { StudioPrintPage } from './pages/StudioPrintPage';
import { StudioSubjectPage } from './pages/StudioSubjectPage';
import { StudioToolsPage } from './pages/StudioToolsPage';
import { CourseDashboardPage, EscritorioRedirectPage } from './pages/CourseDashboardPage';
import { RubricBuilderPage, LegacyEscritorioRubricRedirect } from './pages/RubricBuilderPage';
import { RubricPrintPage } from './pages/RubricPrintPage';
import { StudioSoftShell } from './components/layout/StudioSoftShell';
import { LandingLayout } from './components/layout/LandingLayout';
import { RequireSalaAuth } from './components/auth/RequireSalaAuth';

export default function App() {
  return (
    <Routes>
      <Route element={<LandingLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/join" element={<JoinPage />} />
      </Route>
      <Route path="/host" element={<HostPage />} />
      <Route path="/projector/:code" element={<ProjectorPage />} />
      <Route
        path="/studio"
        element={
          <RequireSalaAuth>
            <StudioSoftShell />
          </RequireSalaAuth>
        }
      >
        <Route index element={<StudioPage />} />
        <Route path="curso/:courseId/rubrica/:id/imprimir" element={<RubricPrintPage />} />
        <Route path="curso/:courseId/rubrica/:id" element={<RubricBuilderPage />} />
        <Route path="curso/:courseId" element={<CourseDashboardPage />} />
        <Route path="material" element={<StudioMaterialPage />} />
        <Route path="exam" element={<StudioMaterialPage />} />
        <Route path="guide" element={<StudioMaterialPage />} />
        <Route path="clase" element={<StudioMaterialPage />} />
        <Route path="print/:examId" element={<StudioPrintPage />} />
        <Route path="herramientas" element={<StudioToolsPage />} />
        <Route path="escritorio/rubrica/:id" element={<LegacyEscritorioRubricRedirect />} />
        <Route path="escritorio" element={<EscritorioRedirectPage />} />
        <Route path="asignatura/:subjectId" element={<StudioSubjectPage />} />
        <Route path=":mode" element={<StudioModePage />} />
      </Route>
    </Routes>
  );
}
